
import { computed, defineComponent, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from '@/store';
import AppNavigation from '@/components/AppNavigation.vue';
import AppSubNavigation from '@/components/AppSubNavigation.vue';
import MdcLinearProgress from '@/components/MdcLinearProgress.vue';
import { initSyncFirestoreWithVuexStore } from './utils';

export default defineComponent({
  name: 'App',
  components: {
    AppNavigation,
    AppSubNavigation,
    MdcLinearProgress
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const isLoading = computed(() => store.getters.internal.get('isLoading'));
    const isSignedIn = computed(() => store.getters.auth.isSignedIn);
    const isInGroup = computed(() => !!store.getters.groups.getGroupId);
    const hasSubNavigationRoutes = computed(() => !!route.matched[0]?.children.length);
    const isOnNoAuthViews = computed(
      () =>
        route.path.includes('sign-in') ||
        route.path.includes('group-create-or-join') ||
        route.path.includes('join-group-with-link')
    );

    onBeforeMount(async () => {
      if (isSignedIn.value && isInGroup.value) {
        await initSyncFirestoreWithVuexStore();
      }
    });

    return {
      isLoading,
      isSignedIn,
      isInGroup,
      hasSubNavigationRoutes,
      isOnNoAuthViews
    };
  }
});
